import { useCallback } from 'react';
import type { GroupTagUpdateItem } from '@/types';
import { GroupTagPicker } from '../AutoComplete/GroupTagPicker';
import { GroupTagSelect } from '../AutoComplete/GroupTagSelect';
import { useGroupTagsDispatch } from './hooks';
import styles from './style.module.css';
import List from './Tags.List';

export default function Editing() {

  const dispatch = useGroupTagsDispatch();

  const handleSelect = useCallback((item: GroupTagUpdateItem) => {


    dispatch(state => ({
      ...state,
      tags: [...state.tags.filter(t => t.id !== item.id), item],
    }));
  }, [dispatch]);

  const handleRemove = useCallback((item: GroupTagUpdateItem) => {
    dispatch(state => ({
      ...state,
      tags: state.tags.filter(t => t.id !== item.id),
    }));
  }, [dispatch]);

  return (
    <>
      <div className={styles.ac}>
        <GroupTagPicker
          onChange={handleSelect} />
      </div>
      <List selected onRemove={handleRemove} />
    </>
  );
}

export { Editing };